<template>
  <div class="mt-2 mx-auto">
    <el-button type="success" @click="getExtendedReviewers">
      Get Extended Reviewers
    </el-button>
    <el-checkbox
      class="ml-4"
      type="warning"
      :checked="showMine"
      @change="handleShowMineToggle"
      >Show Mine</el-checkbox
    >
    <Icon
      icon="material-symbols:refresh"
      class="ml-4 inline"
      :class="{ 'animate-spin': isSpinning }"
      :style="{ fontSize: '36px' }"
    />
    <div v-if="extendedReviewers.length">
      <div class="table-title">Reviewers</div>
      <el-table :data="extendedReviewers" style="width: 100%">
        <el-table-column label="User ID" header-align="center" width="250">
          <template #default="scope">
            {{ scope.row.userEmail }} -- {{ scope.row.userId.slice(-6) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="reviewer"
          label="Reviewer"
          width="150"
          header-align="center"
        >
          <template #default="scope">
            <div class="group relative">
              {{ scope.row.email }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="emailHash"
          label="Email Hash"
          header-align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="invoiceNumber"
          label="Invoice"
          header-align="center"
          width="70"
        ></el-table-column>
        <el-table-column
          prop="status"
          label="Status"
          header-align="center"
          width="100"
        >
          <template #default="scope">
            <div
              :class="{
                'bg-yellow-800': scope.row.status === 'archived',
                'bg-green-800': scope.row.status === 'reviewed',
              }"
            >
              {{ scope.row.status }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdAt"
          label="Created At"
          header-align="center"
          width="200"
        >
          <template #default="scope">
            <div v-if="scope.row.createdAt">
              {{ formatDate(scope.row.createdAt) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="invoice.amountDue"
          label="Due"
          header-align="center"
          width="120"
        >
          <template #default="scope">
            <div v-if="scope.row.invoice">
              {{ formatCurrency(scope.row.invoice.amountDue) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label=""
          width="40"
          header-align="center"
          type="expand"
        >
          <template #default="scope">
            <el-table
              :data="
                scope.row.tracking ? objectToArray(scope.row.tracking) : []
              "
            >
              <el-table-column prop="name" label="Tracked Clicks" width="300">
                <template #default="subScope">
                  {{ displayNames[subScope.row.name] || subScope.row.name }}
                </template>
              </el-table-column>
              <el-table-column label="Value" width="100">
                <template #default="subScope">
                  <ul>
                    <li
                      v-for="(item, index) in subScope.row.value"
                      :key="index"
                    >
                      {{ item.value }}
                    </li>
                  </ul>
                </template>
              </el-table-column>
              <el-table-column label="Time">
                <template #default="subScope">
                  <ul>
                    <li
                      v-for="(item, index) in subScope.row.value"
                      :key="index"
                    >
                      {{ formatDate(item.timestamp, true) }}
                    </li>
                  </ul>
                </template>
              </el-table-column>
            </el-table>
            <div class="mb-8 w-full h-4" />
          </template>
        </el-table-column>
        <el-table-column
          prop="views"
          label="Views"
          header-align="center"
          width="70"
        >
        </el-table-column>
        <el-table-column
          prop="invoice.status"
          label="Inv Status"
          header-align="center"
          width="200"
        >
          <template #default="scope">
            <div
              v-if="scope.row.invoice"
              :class="{
                'bg-yellow-800': scope.row.invoice.status === 'claimed paid',
                'bg-blue-800': scope.row.invoice.status === 'claimed internal',
                'bg-green-800': scope.row.invoice.status === 'paid',
              }"
            >
              {{ scope.row.invoice.status }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import api from "@/composables/api";
import { formatCurrency } from "@/utils";
import { Icon } from "@iconify/vue";
import { formatDate } from "@/utils";

const extendedReviewers = ref([]);
const showMine = ref(false);
const isSpinning = ref(false);
const handleShowMineToggle = (e) => {
  showMine.value = !showMine.value;
  getExtendedReviewers();
};

const objectToArray = (obj) => {
  try {
    if (!obj) {
      throw new Error("Tracking object is null or undefined");
    }
    return Object.keys(obj).map((key) => {
      return { name: key, value: obj[key] };
    });
  } catch (e) {
    console.error(e);
    // expandHasError.value = true;
    return [];
  }
};

const displayNames = {
  starChoiceClicked: "Star Choice Clicks",
  payByCardButtonClicked: "Pay By Card Dropdown Clicks",
  bankWireZelleButtonClicked: "Bank Wire/Zelle Dropdown Clicks",
  choiceReviewButtonClicked: "Review Choice",
};

const getExtendedReviewers = () => {
  isSpinning.value = true;
  api(`v1/reviewer/extended/`).then((res) => {
    if (res.data) {
      //reverse order
      let revs = res.data.reviewers.reverse();
      if (showMine.value == false) {
        revs = revs.filter((r) => {
          return r.userEmail !== "info@herogrow.net";
        });
      }
      extendedReviewers.value = revs;
      isSpinning.value = false;
    }
  });
};
</script>

<style scoped>
.table-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}
</style>
